











































































































































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import { $eventsBus } from "@/main";

export default Vue.extend({
  name: "EndCardLibraryWindow",
  components: { BaseModalWindow, BaseSearchInput, BaseButton },
  data: function () {
    return {
      packshots: [],
      filteredPackshots: [],

      selectedPackshot: null,

      searchValue: "",
      searchSizes: [],
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
  },
  created() {},
  mounted() {
    this.searchSizes.push(
      this.previewItem.currentVariation.currentSize.name.toUpperCase()
    );
    this.updateLibraryFiles();
    $eventsBus.$emit("muteMainContent", true);
    this.updateAllItemsVariationsPackshots();
  },
  watch: {},
  methods: {
    clickSize(size) {
      if (this.searchSizes.includes(size)) {
        this.searchSizes.splice(this.searchSizes.indexOf(size), 1);
      } else {
        this.searchSizes.push(size);
      }
      this.search();
    },
    updateAllItemsVariationsPackshots() {
      this.items.forEach((item) => {
        let isHasEndCardsToDelete = false;
        item.variations.forEach((variation) => {
          if (!variation.endCard.packshot) {
            return;
          } else {
            let updatedPackshot = this.packshots.find(
              (p) => p.packId === variation.endCard.packshot.packId
            );
            if (updatedPackshot) {
              variation.endCard.packshot = updatedPackshot;
              variation.recalcFileOutputParameters();
            }
          }
        });
      });
    },
    checkAllItemsVariationsPackshotsWithThisId(packId) {
      let itemsCount = 0;
      let variationsCount = 0;
      let variationsWithEndCardToDelete = [];
      let message = "";
      this.items.forEach((item) => {
        let isHasEndCardsToDelete = false;
        item.variations.forEach((variation) => {
          if (
            variation.endCard.packshot &&
            variation.endCard.packshot.packId === packId
          ) {
            isHasEndCardsToDelete = true;
            variationsCount++;
            variationsWithEndCardToDelete.push(variation);
          }
        });
        itemsCount += isHasEndCardsToDelete ? 1 : 0;
      });
      message =
        "In " +
        itemsCount +
        " video items in " +
        variationsCount +
        " variations, the End Card will be removed. Continue?";
      if (itemsCount > 0) {
        let isDelete = confirm(message);
        if (isDelete) {
          variationsWithEndCardToDelete.forEach((v) => {
            v.endCard.packshot = null;
            v.recalcFileOutputParameters();
          });
        }
        return isDelete;
      } else {
        return true;
      }
    },
    updateLibraryFiles() {
      this.axios
        .post(
          "/packshots/getVideos",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          response.data.forEach((packshot) => {
            this.packshots.push({ ...packshot });
          });
          this.search();
        });
    },
    filterBySizes() {
      this.filteredPackshots =
        this.searchSizes.length === 0
          ? this.filteredPackshots
          : this.filteredPackshots.filter((p) =>
              this.searchSizes.some((s) => this.isPackshotHasSize(p, s))
            );
    },
    sortBySize() {
      let currentSize = this.previewItem.currentVariation.currentSize.name.toUpperCase();
      this.filteredPackshots.sort((a, b) => {
        return this.isPackshotHasSize(a, currentSize) &&
          !this.isPackshotHasSize(b, currentSize)
          ? -1
          : 1;
      });
    },
    search() {
      if (this.searchValue === "") {
        this.filteredPackshots = this.packshots;
      } else {
        this.filteredPackshots = this.packshots.filter(
          (p) => p.name.toLowerCase().indexOf(this.searchValue) !== -1
        );
      }
      this.filterBySizes();
      this.sortBySize();
    },
    closeWindow() {
      this.selectedPackshot = null;
      $eventsBus.$emit("muteMainContent", false);
      this.$emit("close");
    },
    saveChanges() {
      if (!this.selectedPackshot) {
        return;
      }
      this.previewItem.currentVariation.endCard.packshot = this.selectedPackshot;
      this.previewItem.currentVariation.recalcFileOutputParameters();
      this.closeWindow();
    },
    onAddNewFile() {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      let route = "/packshots/createPack";
      this.axios
        .post(
          route,
          { sessionId: this.$store.state.userInfo.sessionId },
          config
        )
        .then((res) => {
          let newEndCard = {
            packId: res.data.packId,
            name: res.data.name,
            list: [],
          };
          this.onEditPackshot(newEndCard);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isPackshotFileSelected(packshot) {
      return this.selectedPackshot?.packId === packshot.packId;
    },
    onEditPackshot(packshot) {
      $eventsBus.$emit("openEndCardEditWindow", packshot);
    },
    onDeletePackshot(packshot) {
      let isDelete = this.checkAllItemsVariationsPackshotsWithThisId(
        packshot.packId
      );
      if (!isDelete) {
        return;
      }
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      let route = "/packshots/setSettings";
      this.axios
        .post(
          route,
          {
            id: packshot.packId,
            name: packshot.name,
            settings: {
              s: -1,
              f: -1,
              h: -1,
              v: -1,
              p: -1,
            },
            sessionId: this.$store.state.userInfo.sessionId,
          },
          config
        )
        .then((res) => {
          if (
            this.previewItem.currentVariation.endCard.packshot?.packId ===
            packshot.packId
          ) {
            this.previewItem.currentVariation.endCard.packshot = null;
            this.previewItem.currentVariation.recalcFileOutputParameters();
          }
          let indexToDelete = this.packshots.indexOf(packshot);
          this.packshots.splice(indexToDelete, 1);
          this.search();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onClickButton(packshot) {
      if (
        this.isPackshotHasSize(
          packshot,
          this.previewItem.currentVariation.currentSize.name
        )
      ) {
        this.selectedPackshot = packshot;
      }
    },
    isPackshotHasSize(packshot, sizeName) {
      return Object.entries(packshot.list)
        .map((e) => e[0].toLowerCase())
        .includes(sizeName.toLowerCase());
    },
    formatSize(sizeName) {
      switch (sizeName.toUpperCase()) {
        case "S":
          return "1:1";
          break;
        case "F":
          return "4:5";
          break;
        case "P":
          return "2:3";
          break;
        case "V":
          return "9:16";
          break;
        case "H":
          return "16:9";
          break;

        default:
          return sizeName.toUpperCase();
          break;
      }
    },
  },
});
